var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var AbstractViewerController = require("./../../abstractViewerController.js");

var TextInteractionView = require("./textInteractionView.js");
var TextInteractionModel = require("./textInteractionModel.js");

var TextViewerController = function(archLayers, dependencies, configuration) {
    AbstractViewerController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(TextViewerController, AbstractViewerController);
TextViewerController.inject = AbstractViewerController.inject;

module.exports = TextViewerController;

TextViewerController.prototype.beforeLoad = function () {
    AbstractViewerController.prototype.beforeLoad.call(this);
};

TextViewerController.prototype.getDataType = function () {
    return cio_datamodel.TextData;
};

TextViewerController.prototype.getInteractionViewType = function () {
    return TextInteractionView;
};

TextViewerController.prototype.getInteractionModelType = function () {
    return TextInteractionModel;
};
